import React from 'react';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

import moment from 'moment';

import {
  PageContainer,
  Title,
  PureCard,
  RowCustom,
  CarouselResponsive,
  ContainerCustom,
} from 'components';

import { MobileDeviceBreakpoint } from './Header/SearchBarPanel.styles';

import { TitleMain } from '../Main.styles';
import ru from 'moment/locale/ru';
import en from 'moment/locale/en-gb';
const pluralize = require('numeralize-ru').pluralize;

const SearchHistory = ({ dataHistory }) => {
  const intl = useIntl();

  if (localStorage.language === 'ru') {
    moment.locale('ru', ru);
  } else {
    moment.locale('en-gb', en);
  }

  return (
    <>
      <MobileDeviceBreakpoint mobileMGridHidden>
        <TitleMain
          paddingFrom1890="0"
          padding1890="0"
          size="36px"
          weight="500"
          sizeM="18px"
          margin="90px 0 0 0"
        >
          {intl.formatMessage({
            id: 'main-page.resent-search',
          })}
        </TitleMain>
        <RowCustom paddingFrom1890="0" padding1890="0" margin="8px 0 0 0">
          {dataHistory &&
            dataHistory.searchHistory
              .slice(0, 4)
              .map(({ id, checkinDate, checkoutDate, pax, region, url }) => (
                <Link to={url}>
                  <PureCard
                    width="217px"
                    width1100="220px"
                    widthM="217px"
                    height="95px"
                    padding="20px"
                    margin="0 25px 25px 0"
                    marginMobL="9px"
                    style={{
                      boxShadow: '0px 10px 50px rgba(0, 82, 180, 0.1)',
                    }}
                  >
                    <Title size="18px" size="16px" greyText margin="0">
                      <i className="fas fa-search icon-light" />
                      {region.name.length > 10
                        ? `${region.name.slice(0, 10)}...`
                        : region.name}
                    </Title>
                    <Title size="18px" size="16px" greyText>
                      {checkinDate
                        ? `${moment(checkinDate).format('DD MMM, YYYY')}`
                        : intl.formatMessage({
                            id: 'main-page.time',
                          })}
                    </Title>
                  </PureCard>
                </Link>
              ))}
        </RowCustom>
      </MobileDeviceBreakpoint>
      <MobileDeviceBreakpoint tabletGridHidden>
        <PageContainer
          maxWidth="1440px"
          maxWidthSm="580px"
          marginSm="0 0 -30px 0"
          margin="0"
          margin1100="0 0 -30px 0"
          padding1100="0 0 25px"
          padding="0 80px"
          minHeight="auto"
          paddingM="0"
        >
          <TitleMain
            padding1100="0"
            size="36px"
            size1100="24px"
            weight="500"
            sizeM="18px"
            margin="0 0 -20px 0"
          >
            {intl.formatMessage({
              id: 'main-page.resent-search',
            })}
          </TitleMain>
        </PageContainer>
        {dataHistory && (
          <ContainerCustom
            padding="0"
            display="flex"
            wrap="no-wrap"
            overflowX="scroll"
          >
            {dataHistory.searchHistory.map(
              ({ id, checkinDate, checkoutDate, pax, region, url }) => (
                <div>
                  <Link
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      width: 'auto',
                      height: '200px',
                    }}
                    to={url}
                  >
                    <PureCard
                      width="217px"
                      width1100="200px"
                      widthM="200px"
                      height="95px"
                      padding1100="20px 14px"
                      margin="0 25px 25px 0"
                      marginMobL="9px 20px 9px 0"
                      style={{
                        boxShadow: '0px 10px 50px rgba(0, 82, 180, 0.1)',
                      }}
                    >
                      <Title
                        padding1100="0"
                        size="18px"
                        size="14px"
                        greyText
                        margin="0  "
                      >
                        <i className="fas fa-search icon-light" />
                        {region.name.length > 10
                          ? `${region.name.slice(0, 10)}...`
                          : region.name}
                      </Title>
                      <Title padding1100="0" size="18px" size="14px" greyText>
                        {checkinDate &&
                          !checkoutDate &&
                          `${moment(checkinDate).format('DD MMMM, YYYY')}`}
                        {checkinDate &&
                          checkoutDate &&
                          `${moment(checkinDate).format('DD')} - ${moment(
                            checkoutDate
                          ).format('DD MMMM, YYYY')}`}
                        {!checkinDate &&
                          !checkoutDate &&
                          intl.formatMessage({
                            id: 'main-page.time',
                          })}
                      </Title>
                    </PureCard>
                  </Link>
                </div>
              )
            )}
          </ContainerCustom>
        )}
      </MobileDeviceBreakpoint>
    </>
  );
};
export default SearchHistory;
